module.exports = __webpack_public_path__ + "media/components/slider/s4-e6d22e541d877b94535f4854bc2b311f.jpg";